var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.517 4.017c-1.677-.768-6.177-1.842-10.76 0C3.03 6.319.194 12.635 3.245 20.397c3.051 7.762 13.918 11.617 20.449 8.03 6.53-3.587 6.584-11.616 6.156-12.687a7.275 7.275 0 0 1-.166-.508c-.574-1.899-2.262-7.479-10.167-11.215zm-.589.482c-.713-.323-2.762-.826-5.245-.27-3.105.697-9.047 5.14-7.174 11.778 1.873 6.638 7.922 9.475 11.562 9.742 3.64.268 8.458-1.927 9.743-5.139 1.027-2.568 1.391-5.066 1.445-5.994-.464 1.695-1.98 5.503-4.336 7.173-2.355 1.67-3.55 1.98-3.854 1.926 1.374-1.356 3.875-5.075 2.89-9.1-1.178-4.818-4.282-7.227-6.744-8.244-1.44-.594-3.159-1.053-3.908-1.07 1.338-.393 4.336-1.103 5.62-.803z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSos);
export default __webpack_public_path__ + "static/media/SOS.06fc7af79f60385648e04b95a582862c.svg";
export { ForwardRef as ReactComponent };